import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { tap } from 'rxjs/operators';
import { ToastrManager } from 'ng6-toastr-notifications';
import { LocalStorageService } from './local-storage.service';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService {

  constructor(private toastr: ToastrManager,
    private localStorageService: LocalStorageService,
    private router: Router, ) { }
  errorMessage = '';
  requestCount: number = 0;
  intercept(request: HttpRequest<any>, next: HttpHandler) {
    // let value = request.urlWithParams.includes('showHealth_Url');
    // if(!value) {
    //   value = request.body ? request.body.hasOwnProperty('showHealth_Url') : false;
    // }
    let apiReq = request.clone({ url: request.url });
    const token: string = this.localStorageService.getAccessToken();
    let attc = request.url.split('/');
    apiReq = apiReq.clone({
      setHeaders: {
        Authorization: token,
        // 'Content-Type': 'application/json'
      }
    });
    return next.handle(apiReq).pipe(tap(event => {
      if (event instanceof HttpResponse) {
      }
    }, (err: any) => {
      this.errorMessage = '';
      if (err instanceof HttpErrorResponse) {
        if (err.status === 0) {
          const msg = this.localStorageService.getSelectedLanguageValue('General.NoInternetOrBadGateway');
          this.showMessage(msg);
        } else if (err.status === 400) {
          if (this.router.url === '/login') {
            this.showMessage(err.error.error_description);
          } else {
              err.error.validationErrors.filter((elem) => {
              this.errorMessage = this.errorMessage + elem.errorMessage;
            });
            this.showMessage(this.errorMessage);
          }
        } else if (err.status === 401) {
          this.localStorageService.removeLogin();
          this.router.navigate(['/login']);
        } else if (err.status === 403) {
          this.router.navigate(['/403-error']);
        } else if (err.status === 404) {
          const msg = this.localStorageService.getSelectedLanguageValue('General.MethodNotFound');
          this.showMessage(msg);
        } else if (err.status === 405) {
          const msg = this.localStorageService.getSelectedLanguageValue('General.MethodNotAllowed');
          this.showMessage(msg);
        } else if (err.status === 408) {
          const msg = this.localStorageService.getSelectedLanguageValue('General.RequestTimeout');
          this.showMessage(msg);
        } else if (err.status === 415) {
          const msg = this.localStorageService.getSelectedLanguageValue('General.UnsupportedMediaType');
          this.showMessage(msg);
        } else if (err.status === 500) {
          const msg = this.localStorageService.getSelectedLanguageValue('General.SomeThingWentWrong');
          this.showMessage(msg);
        } else if (err.status === 502) {
          const msg = this.localStorageService.getSelectedLanguageValue('General.BadGateway');
          this.showMessage(msg);
        } else if (err.status === 503) {
          const msg = this.localStorageService.getSelectedLanguageValue('General.ServiceUnavailable');
          this.showMessage(msg);
        } else if (err.status === 504) {
          const msg = this.localStorageService.getSelectedLanguageValue('General.GatewayTimeout');
          this.showMessage(msg);
        }
      }
    }
    ));
  }
  private showMessage(errorMessage) {
    this.toastr.errorToastr(errorMessage);
  }
}